import type { EmblaCarouselType } from 'embla-carousel';

// Match ProductCarousel's existing responsive slide bases.
export function getProductCarouselStep(viewportWidth: number): number {
  if (viewportWidth < 640) return 1;
  if (viewportWidth < 768) return 2;
  if (viewportWidth < 1024) return 3;
  return 4;
}

type ProductCarouselNavigation = Pick<
  EmblaCarouselType,
  'canScrollNext' | 'selectedScrollSnap' | 'scrollTo'
>;

/** One animation per turn; Embla itself retains its loop/clamp semantics. */
export function advanceProductCarousel(
  api: ProductCarouselNavigation | null | undefined,
  viewportWidth: number,
): boolean {
  if (!api?.canScrollNext()) return false;
  api.scrollTo(api.selectedScrollSnap() + getProductCarouselStep(viewportWidth));
  return true;
}
